import store from './store'
import * as types from './store/mutation-types'

const notifyUserAboutUpdate = worker =>
  store.dispatch(types.NEW_UPDATE, {
    text: 'Hay una nueva actualización disponible, recarga por favor.'
  })

export function registerValidSW (swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      if (registration.waiting) {
        console.log('New content has been available from last session; please refresh.')
        notifyUserAboutUpdate(registration.waiting)
        return
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the fresh content will have been added to the cache.
              // It's the perfect time to display a "New content is
              // available; please refresh." message in your web app.
              console.log('New content is available; please refresh.')
              notifyUserAboutUpdate(installingWorker)
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.')
            }
          }
        }
      }
    })
    .catch(error => {
      console.error('Error during service worker registration:', error)
    })
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js